import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "components/ui/Select";
import { useAllSchemeMasters, useGenerateSchemePrint } from "http-hooks/schemeMaster/useSchemeMaster";
import { getDocumentUrls, getDocumentViewerRoute } from "utils/documentUrlHelper";

const SchemePrint = () => {
  const navigate = useNavigate();
  const [selectedScheme, setSelectedScheme] = useState(null);

  const { data: schemesData, isLoading: loadingSchemes } = useAllSchemeMasters({
    noPagination: true,
  });

  const { mutateAsync: generateReport, isPending: isGenerating } =
    useGenerateSchemePrint();

  const schemeOptions =
    schemesData?.data?.map((scheme) => ({
      value: scheme.schemeid,
      label: `${scheme.sch_name} | ${scheme.vendorDetail?.name || scheme.vendor}`,
    })) || [];

  const handleGenerateReport = async () => {
    try {
      if (!selectedScheme) {
        toast.error("Please select a scheme");
        return;
      }

      const data = await generateReport({ schemeid: selectedScheme.value });
      const { htmlUrl, pdfUrl } = getDocumentUrls(data);

      navigate(
        getDocumentViewerRoute(selectedScheme.value, {
          htmlUrl,
          pdfUrl,
          documentNumber: selectedScheme.label.split(" | ")[0],
          documentType: "Scheme Print",
        })
      );
    } catch (error) {
      console.error("Error generating report:", error);
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-semibold leading-6 text-gray-900 text-center">
        Scheme Print
      </h1>

      <div className="max-w-md mx-auto mt-6 space-y-4">
        <Select
          label="Scheme *"
          options={schemeOptions}
          value={selectedScheme}
          onChange={setSelectedScheme}
          placeholder="Select scheme"
          isLoading={loadingSchemes}
          isSearchable={true}
          isClearable={true}
        />

        <div className="flex justify-center pt-2">
          <button
            type="button"
            onClick={handleGenerateReport}
            disabled={isGenerating || !selectedScheme}
            className="rounded-md bg-indigo-600 px-8 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isGenerating ? "Generating..." : "Generate Report"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SchemePrint;
